let reportCount = 0;

export default url => {
    const apiReportMaxCount = typeof window.__apiReportMaxCount === 'number' ? window.__apiReportMaxCount : 50;

    if (typeof BJ_REPORT === 'object' && window.__apiReport === true && apiReportMaxCount > reportCount) {
        if (typeof performance === 'object' && typeof performance.getEntries === 'function') {
            const entrys = performance.getEntries();

            for (let i = entrys.length - 1; i > 0; i--) {
                const entry = entrys[i];

                if (entry.name.includes(url)) {
                    window.BJ_REPORT.report(
                        new Error(JSON.stringify({ costTime: entry.duration, url: url.substring(0, 200) })),
                        false,
                        'slowApi',
                    );
                    break;
                }
            }
        }
    }

    reportCount++;
};
